import React, { useEffect, useState } from 'react';
import styles from './NewsPage.module.scss';
import { useParams } from 'react-router-dom';
import LoaderButton from '../../Molecules/Loader/LoaderButton';
import NewsTopHeader from '../../Molecules/TableTopHeader/NewsTopHeader';
import { useFetchMediaGalleryById } from '../../../Hooks/Media';
import GalleryItem from '../../Molecules/NewsAndEvents/GalleryItem';
import { isEmpty } from 'lodash';
import UploadImageModal from '../../Molecules/NewsAndEvents/UploadImageModal';
import NoDataComponent from '../../Molecules/Custom/NoDataComponent/NoDataComponent';
import Loader from '../../Molecules/Loader/Loader';
import renameIcon from '../../../assets/Imagess/rename-icon.svg';
import RenameMediaModal from '../../Molecules/NewsAndEvents/RenameMediaModal';

const MediaGallery = () => {
  const params = useParams();
  const { id } = params;
  const { data, refetch, isLoading } = useFetchMediaGalleryById({ id });
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0); // New state for the current index

  useEffect(() => {
    if (!isEmpty(id) && id !== undefined) {
      refetch();
    }
  }, [id]);

  const handleNavigate = (e) => {
    e.preventDefault();
    setShowCreateModal(true);
  };

  const title = (
    <div className={styles['media-header-title']}>
      <div>
        <h1>{data?.data?.galleryName_AR}</h1>{' '}
        <img
          src={renameIcon}
          aly='rename-icon'
          onClick={() => setShowRenameModal(true)}
        />
      </div>
      <h3>
        وسائط/<span>{data?.data?.galleryName_AR}</span>
      </h3>
    </div>
  );

  return (
    <div>
      <div className={styles['gallery-container']}>
        <NewsTopHeader
          handleNewClick={handleNavigate}
          type='gallery'
          style={{
            paddingTop: '0px !important',
            paddingBottom: '35px',
            paddingRight: '0px',
            paddingLeft: '0px',
          }}
          title={title}
        />
        {isLoading ? (
          <Loader />
        ) : data?.data?.images?.length > 0 ? (
          <div className={styles['gallery-box-grid']}>
            {data?.data?.images.map((item, index) => (
              <GalleryItem
                media={item}
                refetchMedia={refetch}
                mediaImages={data?.data?.images}
                key={item?.mediaGalleryDetailsId}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                index={index} // Pass down the index of each item
              />
            ))}{' '}
          </div>
        ) : (
          <NoDataComponent text='No Images' />
        )}
      </div>
      {showCreateModal && (
        <UploadImageModal
          handleOnClose={() => setShowCreateModal(false)}
          refetch={refetch}
          id={id}
        />
      )}
      {showRenameModal && (
        <RenameMediaModal
          media={data?.data}
          handleOnClose={() => setShowRenameModal(false)}
          refetchMedia={refetch}
        />
      )}
    </div>
  );
};

export default MediaGallery;
